import { Component, Input } from '@angular/core';
import {NgStyle} from "@angular/common";

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  standalone: true,
  styleUrl: './banner.component.scss',
  imports: [
    NgStyle
  ]
})
export class BannerComponent {

  @Input() icon = '';

  @Input() text = '';

  @Input() color = '';
}
